var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Greatest lower bound (meet) of the given positions, computed by folding a
 * pairwise meet over them. The pairwise meet of A and B is
 * findForkPosition(A, B).commonFrontier (the frontier of the shared history).
 *
 * The meet of a set equals the meet of its causally-minimal elements, so any
 * generating set works -- callers may fold directly over fork.common without
 * first reducing it to an antichain. Disconnected positions meet to the empty
 * set. Each fold step uses the (indexed) findForkPosition, so this avoids any
 * un-indexed predecessor walk.
 *
 * Future: a native N-ary meet at the index level would avoid the O(k) folds.
 */
export function computeMeet(positions, pairwiseMeet) {
    return __awaiter(this, void 0, void 0, function* () {
        if (positions.length === 0) {
            return new Set();
        }
        let acc = positions[0];
        for (let i = 1; i < positions.length; i++) {
            if (acc.size === 0)
                break; // meet with the empty position stays empty
            acc = yield pairwiseMeet(acc, positions[i]);
        }
        return acc;
    });
}
